import { ssDispatch } from '~SpectateStore';
import { inplayEventUpdate } from '~SpectateStore/actions/inplayEventUpdate';
import { inplayScoreboardUpdate } from '~SpectateStore/actions/inplayScoreboardUpdate';

/**
 * A WS Event Update handler for Inplay Page that updates Redux Global Store
 * based on [message.actions]
 * @param  { Object } message message from websocket
 * @param  { Number | String } eventId inplay [event.id]
 * @return { void }
 */
export function inplayWSHandler(message, eventId) {
  if ((message.action === 'price_update') && Number(message.events[0].id) === Number(eventId)) {
    ssDispatch(inplayEventUpdate(message));
  }

  if (message.action === 'inplay_update' && Number(message.events[0].id) === Number(eventId)) {
    ssDispatch(inplayScoreboardUpdate(message));
  }
}
